import React, { Component } from 'react';
import {



  Table,
  Tooltip,
  OverlayTrigger,

} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import ReactLoading from 'react-loading';
import { userService } from '../../../services/user';

class UserList extends Component{
	constructor(props){
    	super(props);
		this.state = {
			users : this.props.userProp.length > 0 ? this.props.userProp :{},
			currentUserId : this.props.userId || '',
			userTypeTitle : this.props.userTypePro || '',
			adminUser : this.props.adminUserPro || '',
			componentType: this.props.componentPro || '',
			addModalUser: false,
			loader:{},
		}
		const loaderTemp = {...this.state.loader};
		this.state.users.map((user, id) => {
			loaderTemp[id] = false
		});
		this.handleUserCheckBox = this.handleUserCheckBox.bind(this);
	}

	handleUserCheckBox(userId, key){
		console.log('key', key);
		const loaderTempNew = {...this.state.loader};
			loaderTempNew[key] = true;

		this.setState({loader: loaderTempNew}, function(){
			this.props.changePrimaryUserParPro(userId);
		});
		
	}
	showPassword = (data) => {
        return userService.showPassword(data);
    }

	showPasswordModal = (userId) => {
	  this.showPassword({user_id: userId}).then(response => {
		confirmAlert({
			customUI: ({ onClose }) => {
			  return (
				<div className='custom-ui'>
				  <div className="react-confirm-alert-body">
					<h3>User Data</h3>
					<p className="marginFromTopPopUp" >Password for <span style={{fontWeight: 'bold'}}>{response.user.email}</span>:<span style={{color: 'red', fontWeight: 'bold'}}>{response.user.enc_password}</span></p>
					<div className="react-confirm-alert-button-group">
					  <button onClick={onClose}>Close</button>
					</div>
				  </div>
				  
				</div>
			  )
			}
		  })
		
	  })
	}
	
	render(){
		const { users, currentUserId, userTypeTitle, adminUser, componentType, loader } = this.state;
		return(
			<div>
			{
				adminUser &&
				<Table striped hover className="myTable">
		            <thead>
		              <tr>
		              	<th>Name</th>
		                <th>Email</th>
		                <th al={console.log('lllllllllll',adminUser)}>Phone</th>
		                {
		                	((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) && componentType === 'companyUser' &&
		                	<th className="text-center" >Primary Contact</th>	
		                }
		                {
	                		((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) &&
		                	<th>Actions</th>
		            	}
		               </tr>
		            </thead>
		            <tbody>
		            	{
		            		users.map((prop, key) => {
		                		return (
	                				<tr key={key}>
	                					<td>{prop.name}</td>
	                					<td>{prop.email}</td>
	                					<td>{prop.phone}</td>
	                					{
		                					((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) && componentType === 'companyUser' &&
	                						<td align="center">
	                							{
	                								loader[key] &&
	                								<ReactLoading type="bars" color="#1DC7EA" height={5} width={40} className="loaderCustom"/>
	                							}
	                							{
	                								!loader[key] &&
	                								<label className="container-radio no_label">
								                        <input type="radio" name="permission" className="checkbox" checked={prop.permission?true:false} onChange={()=>this.handleUserCheckBox(prop.id, key)} />
								                        <span className="checkmark"></span>
							                      	</label>
	                								
	                							}
	                							
	                						</td>
	                					}
	                					{
	                						((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) &&
	                						<td >
	                						
	                							<div>
	                							<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Edit { userTypeTitle }</Tooltip>}>
			                              			<button type='button' className="action-button-size" onClick={() => this.props.openModalUserEditProp(prop.id)}><i className="fa fa-pencil" /></button>
			                            		</OverlayTrigger>
	                							{
							                      prop.id !== currentUserId && prop.permission === 0 &&
							                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Delete { userTypeTitle }</Tooltip>}>
							                        <button type='button' className="action-button-size" onClick={() => this.props.deleteConfirmUserProp(prop.id)}><i className="fa fa-trash " /></button>
							                      </OverlayTrigger>
							                    }
												{
													((adminUser.type === 'admin') || (adminUser.type === 'company' && adminUser.user.permission === 1) ) && componentType === 'companyUser' &&
													<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">View User</Tooltip>}>
														<span>
															<button  className='action-button-size'  onClick={() => this.showPasswordModal(prop.id)} ><i className="fa fa-eye " /></button>
														</span>
													</OverlayTrigger>
												}
	                							</div>
		                        
		                					</td>
		                				}
		                			</tr>
		                		);
		            		})
		            	
		            	}
		            </tbody>
		        </Table>
	    	}
	    	</div>
		);
	}
}

export default UserList;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/UserList.jsx